export const getEnvVariables = () => ({
  ...process.env,
  elevenlabsApiKey: process.env.REACT_APP_ELEVENLABS_API_KEY,
  nodeEnv: process.env.REACT_APP_NODE_ENV,
  // Support both VITE_API_URL and REACT_APP_VITE_API_URL for compatibility
  VITE_API_URL: process.env.REACT_APP_VITE_API_URL || process.env.VITE_API_URL,
});
